import React from 'react'
import { Tooltip } from 'antd'
import { ConnectorType } from '../../models/connector'
import { J1722ConnectorSVG, CCSPlugForDCFastChargingSVG, CHAdeMOConnectorSVG, J3400ConnectorSVG } from '../../assets/svg/connectorPlug'

interface ConnectorTypeDisplayProps {
  connectorType?: ConnectorType | string
  showIcon?: boolean
  showText?: boolean
  className?: string
}

export const ConnectorTypeDisplay: React.FC<ConnectorTypeDisplayProps> = ({
  connectorType,
  showIcon = true,
  showText = true,
  className = '',
}) => {
  if (!connectorType) {
    return <span className={className}>-</span>
  }

  const getConnectorIcon = (type: string) => {
    switch (type) {
      case 'J1772':
        return J1722ConnectorSVG
      case 'CCS':
        return CCSPlugForDCFastChargingSVG
      case 'CHAdeMO':
        return CHAdeMOConnectorSVG
      case 'J3400':
        return J3400ConnectorSVG
      // For connector types without specific icons, we'll show text only
      case 'Tesla':
      case 'Type 2':
      case 'Type 1':
      case 'Type 3':
      case 'GB/T':
      case 'Other':
      default:
        return null
    }
  }

  const icon = getConnectorIcon(connectorType)

  return (
    <div className={`connector-type-display ${className}`} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {showIcon && icon && (
        <Tooltip title={connectorType}>
          {icon}
        </Tooltip>
      )}
      {showText && !icon && (
        <span>{connectorType}</span>
      )}
    </div>
  )
}
